import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import TabsCTO from "../payout-tabs/TabsCTO";
import TotalCtoCost from "./TotalCtoCost";
import Modal from "react-modal";
import AddCtoHead from "./AddCtoHead";
import { fetchCTOData } from "../../../redux/reducers/apiSlice";
import ButtonDice from "../common/ButtonDice";
import CreateNewCTO from "./CreateNewCTO";
import ModalHeadAndClose from "../common/ModalHeadAndClose";
import EmptyMessage from "../common/EmptyMessage";
import { selectAuth } from "../../auth/auth.selector";

function CTO() {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});

  const initialCTOTabsData = {
    allCTOData: [],
    wtfCTOData: [],
    gymCTOData: [],
  };
  const [allCTODataValues, setAllCTODataValues] = useState(initialCTOTabsData);
  const [totalCTOcost, setTotalCTOcost] = useState(0);
  const [ctoHeadModal, setCtoHeadModal] = useState(false);
  const [createCTOModal, setCreateCTOModal] = useState(false);

  const { ctoData, loading, error } = useSelector((state) => state.api);
  const selectedGym = useSelector((state) => state?.filters?.selectedGym);
  const selectedYear = useSelector((state) => state?.filters?.selectedYear);
  const selectedMonth = useSelector((state) => state?.filters?.selectedMonth);
  // const startAndEndDate = useSelector((state) => state?.filters?.startAndEndDate);

  // const startDate = new Date(startAndEndDate.startDate);
  // const startYear = startDate.getFullYear();
  // const endDate = new Date(startAndEndDate.endDate);
  // const endMonth = endDate.getMonth() + 1;

  const page = 1;
  const selectedGymQueryParam = selectedGym
    ? `&gym_id=${selectedGym?.value}`
    : "";
  const selectedYearQueryParam = selectedYear
    ? `&year=${selectedYear?.value}`
    : "";
  const selectedMonthQueryParam = selectedMonth
    ? `&month=${selectedMonth?.value}`
    : "";
  // const startDateQueryParam = startAndEndDate.startDate ? `&year=${startYear}` : '';
  // const endDateQueryParam = startAndEndDate.endDate ? `&month=${endMonth}` : '';
  const queryParameters = `page=${page}${selectedGymQueryParam}${selectedYearQueryParam}${selectedMonthQueryParam}`;

  useEffect(() => {
    if (selectedGym) {
      dispatch(fetchCTOData({ queryParameters, token: decryptedText?.token }));
    }
  }, [selectedGym, selectedYear, selectedMonth]);

  useEffect(() => {
    if (ctoData?.status && ctoData?.data) {
      const { data } = ctoData;

      const categorizedData = data.reduce(
        (acc, ctoItem) => {
          if (ctoItem.cto_type === "wtf") {
            acc.wtfCTOData.push(ctoItem);
          } else if (ctoItem.cto_type === "gym") {
            acc.gymCTOData.push(ctoItem);
          }
          return acc;
        },
        {
          wtfCTOData: [],
          gymCTOData: [],
        }
      );

      setAllCTODataValues({
        ...allCTODataValues,
        allCTOData: data,
        wtfCTOData: categorizedData.wtfCTOData,
        gymCTOData: categorizedData.gymCTOData,
      });

      setTotalCTOcost(ctoData.total);
    }
  }, [ctoData]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  return (
    <Container fluid className="container">
      <Modal
        isOpen={ctoHeadModal}
        onRequestClose={() => setCtoHeadModal(false)}
        contentLabel="Payouts Modal"
        ariaHideApp={false}
      >
        <AddCtoHead onClose={() => setCtoHeadModal(false)} />
      </Modal>

      <Modal
        isOpen={createCTOModal}
        onRequestClose={() => setCreateCTOModal(false)}
        contentLabel="Create New CTO Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer">
          <ModalHeadAndClose
            title=""
            onClose={() => setCreateCTOModal(false)}
          />
          <CreateNewCTO />
        </div>
      </Modal>

      <Row>
        <Col>
          <div className="createNewSettlementBtn">
            <ButtonDice
              buttonText1="New Head"
              buttonText2="Create New CTO"
              onClickButton1={() => setCtoHeadModal(true)}
              onClickButton2={() => setCreateCTOModal(true)}
            />
          </div>
        </Col>
      </Row>

      {!selectedGym ? (
        <Row>
          <Col>
            <EmptyMessage />
          </Col>
        </Row>
      ) : (
        <>
          <Row>
            <Col>
              <TotalCtoCost totalCTOcost={totalCTOcost} />
            </Col>
          </Row>

          <Row>
            <Col>
              <TabsCTO allCTODataValues={allCTODataValues} />
            </Col>
          </Row>
        </>
      )}
    </Container>
  );
}

export default CTO;
